import script from "./cardList.vue?vue&type=script&setup=true&lang=js"
export * from "./cardList.vue?vue&type=script&setup=true&lang=js"

import "./cardList.vue?vue&type=style&index=0&id=40a0f61a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a0f61a"]])

export default __exports__